module.exports = __webpack_public_path__ + "20_cikm.jpg?2567ea9b86db66f54b0f8094548b8083";


//////////////////
// WEBPACK FOOTER
// ./src/assets/paperImg/20_cikm.jpg
// module id = 171
// module chunks = 0